/** форма пользователя
 * в общем виде является высокоприоритетной формой, которая позволяет
 * 1) изменить логин и пароль
 * 2) обновить права доступа
 * 3) добавить телефон и емейл (возможно с их проверкой на принадлежность одноразовым кодом)
 * 4) что-то еще
 *
 * может использовать общие компоненты из пользовательских настроек (загрузить фото и сменить пароль)
 *
 */
import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useParams, useRouteMatch } from "react-router-dom";
import IntlMessages from "util/intlMessages";
import PageTitle from "components/standart/PageTitle";

import PartnerData from "./Data";
import { Alert } from "reactstrap";

import { adminAPI } from "redux/api";
import { apiUrls, formLink } from "./init";

const { api } = adminAPI.actions;

export const ident = "Users.User.Save";

const PartnerForm = (props) => {
  const { url } = useRouteMatch();
  const params = useParams();
  const { partner, setPartner, breadCrumbs } = props;

  breadCrumbs.push({
    title: <IntlMessages id={ident} />,
    url,
  });

  const [dataSaved, setDataSaved] = useState(false);
  const saveHandler = (req, res) => {
    res.onSuccess = (body) => {
      setPartner(body);
      setDataSaved(true);
    };
    props.saveData({ ...req, params }, res);
  };

  const successAlertRef = useRef();
  useEffect(() => {
    if (dataSaved) {
      successAlertRef.current.scrollIntoView();
    }
  }, [dataSaved]);

  return (
    <>
      <PageTitle {...breadCrumbs} />

      <div ref={successAlertRef}>
        <Alert className="alert-success" isOpen={dataSaved} toggle={() => setDataSaved(false)}>
          <IntlMessages id="saved" />
        </Alert>
      </div>

      <div className="row">
        <div className="col-12 col-lg-6 col-xl-6">
          <div className="roe-card-style">
            <div className="roe-card-header">{<IntlMessages id="Partners.Info" />}</div>
            <div className="roe-card-body">
              <PartnerData
                {...{ partner, setPartner }}
                requestHandler={() => setDataSaved(false)}
                saveHandler={saveHandler}
              />
            </div>
            {/* 
            <div className="roe-card-body">
              <div className="h6">
                <IntlMessages id="settings.photo" />
              </div>
              <PhotoUploader userSettings={partner.settings} changePhotoHandler={changePhoto} />
            </div>
            */}
          </div>
        </div>
        {/*
        <div className="col-12 col-lg-6 col-xl-6">
          <div className="roe-card-style">
            <div className="roe-card-header">{<IntlMessages id="settings.changePassword" />}</div>
            <div className="roe-card-body">
              <ChangePassword changePasswordHandle={changePassword} />
            </div>
          </div>
          <br />
          <div className="roe-card-style">
            <div className="roe-card-header">
              <IntlMessages id="Users.Form.changePhone" />
            </div>
            <div className="roe-card-body">
              <UserPhone {...{ partner, setPartner, saveDataHandler }} />
            </div>
          </div>
        </div>
        */}
      </div>
    </> ///
  );
};

export const FormButton = (props) => {
  return (
    <Link to={formLink(props)} className={props.className}>
      <i className="fa fa-edit" />
    </Link>
  );
};

export default connect(null, {
  saveData: api.patch(apiUrls.info),
})(PartnerForm);
